var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntMag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_516_1",
    "data-name": "Component 516 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.982,
    height: 29.04,
    viewBox: "0 0 65.982 29.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 65.982,
    height: 29.04,
    fill: "#fdfdfd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M15.293,4.36,10.059,8.384,0,.653V21.786H5.211V11.231l1.6,1.223,3.248,2.515L13.3,12.458l1.606-1.227V21.786h5.211V.653Z",
    transform: "translate(0 -0.481)",
    fill: "#fdfdfd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_545_1",
    "data-name": "Component 545 \\u2013 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M181.337,5.837h10.607V.342H181.337a10.607,10.607,0,1,0,0,21.215h10.607V8.981H180.3v5.5h6.151v1.586h-5.112a5.112,5.112,0,0,1,0-10.225",
    transform: "translate(-125.963 -0.252)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M101.46,16.631,92.985,0,84.512,16.63,82.118,21.3h5.844L89.9,17.526l3.089-6.057,3.09,6.058L98.009,21.3h5.843Z",
    transform: "translate(-60.586 0)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M120.432,69.807a1.727,1.727,0,1,1-1.727-1.727,1.727,1.727,0,0,1,1.727,1.727",
    transform: "translate(-86.306 -50.229)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3.742,97.217a4.076,4.076,0,0,1-.968.109,2.809,2.809,0,0,1-1-.173,2.315,2.315,0,0,1-.786-.486,2.215,2.215,0,0,1-.515-.751,2.658,2.658,0,0,1,0-1.959A2.189,2.189,0,0,1,1,93.205a2.311,2.311,0,0,1,.78-.476,2.749,2.749,0,0,1,.965-.166,2.969,2.969,0,0,1,1,.163,2.066,2.066,0,0,1,.748.438l-.69.786a1.2,1.2,0,0,0-.422-.3,1.431,1.431,0,0,0-.595-.119,1.318,1.318,0,0,0-.53.106,1.272,1.272,0,0,0-.422.294,1.329,1.329,0,0,0-.278.448,1.569,1.569,0,0,0-.1.566,1.774,1.774,0,0,0,.089.575,1.242,1.242,0,0,0,.265.451,1.209,1.209,0,0,0,.435.294,1.557,1.557,0,0,0,.591.105,2.191,2.191,0,0,0,.364-.029,1.352,1.352,0,0,0,.32-.093V95.42H2.652v-.882H4.519v2.4a3.5,3.5,0,0,1-.777.281",
    transform: "translate(-0.212 -68.292)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M27.139,97.553l-.982-1.8h-.373v1.8H24.716V93.027h1.726a2.99,2.99,0,0,1,.636.067,1.652,1.652,0,0,1,.556.227,1.189,1.189,0,0,1,.393.422,1.318,1.318,0,0,1,.147.652,1.2,1.2,0,0,1-.249.773,1.361,1.361,0,0,1-.69.448l1.183,1.937Zm-.045-3.139a.451.451,0,0,0-.068-.259A.463.463,0,0,0,26.853,94a.761.761,0,0,0-.238-.074,1.784,1.784,0,0,0-.254-.019h-.585v1.055h.52a1.762,1.762,0,0,0,.276-.022.893.893,0,0,0,.257-.08.463.463,0,0,0,.264-.447",
    transform: "translate(-18.235 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M49.879,94.928a2.53,2.53,0,0,1-.185.981,2.236,2.236,0,0,1-.515.76,2.291,2.291,0,0,1-.783.489,2.754,2.754,0,0,1-.985.173,2.726,2.726,0,0,1-.981-.173,2.3,2.3,0,0,1-.78-.489,2.229,2.229,0,0,1-.515-.76,2.521,2.521,0,0,1-.185-.981,2.492,2.492,0,0,1,.185-.981,2.148,2.148,0,0,1,.515-.745,2.3,2.3,0,0,1,.78-.473,2.812,2.812,0,0,1,.981-.166,2.841,2.841,0,0,1,.985.166,2.294,2.294,0,0,1,.783.473,2.155,2.155,0,0,1,.515.745,2.5,2.5,0,0,1,.185.981m-1.17,0a1.558,1.558,0,0,0-.1-.55,1.314,1.314,0,0,0-.265-.438,1.226,1.226,0,0,0-.409-.288,1.294,1.294,0,0,0-.527-.105,1.255,1.255,0,0,0-.933.393,1.241,1.241,0,0,0-.265.438,1.695,1.695,0,0,0,0,1.115,1.343,1.343,0,0,0,.265.444,1.211,1.211,0,0,0,.406.291,1.359,1.359,0,0,0,1.048,0,1.247,1.247,0,0,0,.409-.291,1.316,1.316,0,0,0,.269-.444,1.621,1.621,0,0,0,.1-.566",
    transform: "translate(-33.164 -68.292)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M74.95,96.59a1.623,1.623,0,0,1-.393.575,1.822,1.822,0,0,1-.617.374,2.478,2.478,0,0,1-1.608,0,1.754,1.754,0,0,1-.608-.374,1.627,1.627,0,0,1-.383-.575,1.991,1.991,0,0,1-.134-.745v-2.82h1.087v2.73a1.263,1.263,0,0,0,.048.352.9.9,0,0,0,.147.3.69.69,0,0,0,.262.208,1.048,1.048,0,0,0,.786,0A.716.716,0,0,0,73.8,96.4a.823.823,0,0,0,.147-.3,1.345,1.345,0,0,0,.045-.352v-2.73h1.093v2.82a1.951,1.951,0,0,1-.137.745",
    transform: "translate(-52.536 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M97.679,94.42a1.388,1.388,0,0,1-.147.668,1.207,1.207,0,0,1-.4.438,1.741,1.741,0,0,1-.575.243,2.952,2.952,0,0,1-.678.077h-.543v1.707H94.246V93.026h1.662a3.119,3.119,0,0,1,.694.074,1.634,1.634,0,0,1,.563.237,1.149,1.149,0,0,1,.377.428,1.413,1.413,0,0,1,.137.655m-1.093.007a.486.486,0,0,0-.064-.262.444.444,0,0,0-.173-.16.731.731,0,0,0-.246-.077,2.051,2.051,0,0,0-.285-.019h-.48v1.067h.46a1.619,1.619,0,0,0,.294-.026.8.8,0,0,0,.253-.089.478.478,0,0,0,.176-.169.5.5,0,0,0,.064-.265",
    transform: "translate(-69.534 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M125.695,97.552V93.026h1.1V96.6h1.752v.952Z",
    transform: "translate(-92.737 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 1.099,
    height: 4.526,
    transform: "translate(37.599 24.392)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M160.126,97.552l.025-3.2h-.019l-1.176,3.2h-.767l-1.144-3.2h-.019l.025,3.2h-1.029V93.026h1.555l1.03,2.9h.026l.986-2.9H161.2v4.526Z",
    transform: "translate(-115.112 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 1.099,
    height: 4.526,
    transform: "translate(48.294 24.392)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M197.522,93.96v3.593h-1.093V93.96h-1.279v-.933h3.65v.933Z",
    transform: "translate(-143.98 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M215.849,97.552V93.026h3.043v.921H216.9V94.8h1.88v.876H216.9v.94h2.1v.933Z",
    transform: "translate(-159.252 -68.634)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M239.748,95.276a2.227,2.227,0,0,1-.221,1.026,2.062,2.062,0,0,1-.582.71,2.426,2.426,0,0,1-.815.409,3.3,3.3,0,0,1-.92.131h-1.688V93.026h1.636a4.065,4.065,0,0,1,.946.112,2.378,2.378,0,0,1,.831.371,1.9,1.9,0,0,1,.588.694,2.328,2.328,0,0,1,.224,1.074m-1.138,0a1.43,1.43,0,0,0-.125-.636,1.076,1.076,0,0,0-.332-.4,1.341,1.341,0,0,0-.473-.214,2.331,2.331,0,0,0-.546-.064h-.543v2.646h.518a2.345,2.345,0,0,0,.566-.067,1.334,1.334,0,0,0,.48-.221,1.1,1.1,0,0,0,.332-.409,1.434,1.434,0,0,0,.125-.633",
    transform: "translate(-173.767 -68.634)",
    fill: "#fdfdfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntMag);
export default __webpack_public_path__ + "static/media/ent-mag.b62f9bcef728421156b067884ffecc82.svg";
export { ForwardRef as ReactComponent };